module.exports = __webpack_public_path__ + "static/media/blackpepper.48c09362.png";